import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { normalizeReferralCode, setStoredReferralCode } from '../../../utils/referral';
import { ACCOUNT, SIGNUP } from '../../../routes/routeConstants';

const ReferralCapture = () => {
  const navigate = useNavigate();
  const { code } = useParams<{ code: string }>();

  useEffect(() => {
    const referralCode = normalizeReferralCode(code || '');
    if (referralCode) {
      setStoredReferralCode(referralCode);
    }

    navigate(`/${ACCOUNT}/${SIGNUP}${referralCode ? `?ref=${referralCode}` : ''}`, { replace: true });
  }, [code, navigate]);

  return null;
};

export default ReferralCapture;
